import React from "react";

export const AppConfigContext = React.createContext<
  [boolean, React.Dispatch<React.SetStateAction<boolean>>]
>([false, (value: boolean) => {}] as any);
